const swiper = new Swiper(".gallerySwiper", {
    loop: true,
    speed: 500,
    autoplay: {
        delay: 3000,
        pauseOnMouseEnter: true
 },
});